import React from "react"
import styled from "styled-components"

import { CloseIcon, SpinnerIcon } from "client/components"
import { IDLE, PENDING } from "const"


const CloseButton = styled.div`
    line-height: 0;
    user-select: none;
    cursor: pointer;
    color: ${(props) => props.theme.deleteButtonIdleColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.deleteButtonIdleHoverColor};
        transition: ${(props) => props.theme.defaultTransition};
    }

    & > i {
        font-size: 18px;
    }
`
const SpinnerButton = styled.div`
    user-select: none;
    cursor: pointer;
    pointer-events: none;
    color: ${(props) => props.theme.deleteButtonSpinnerColor};

    & > i {
        font-size: 20px;
    }
`

export interface DeleteButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    status: typeof IDLE | typeof PENDING
}
export const DeleteButton = ({
    status,
    ...other
}: DeleteButtonProps) => {
    if (status === IDLE) {
        return (
            <CloseButton {...other}>
                <CloseIcon />
            </CloseButton>
        )
    }
    if (status === PENDING) {
        return (
            <SpinnerButton {...other}>
                <SpinnerIcon />
            </SpinnerButton>
        )
    }
    return null
}
